import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-watch-tower-card',
  templateUrl: './watch-tower-card.component.html',
  styleUrls: ['./watch-tower-card.component.less']
})
export class WatchTowerCardComponent implements OnInit {
  ngOnInit(): void {
    console.debug('GOT AN EVENT',this.chnlData)
  }

  @Input() chnlData : any;
}
